import React from 'react';
import { WithTestIdOptional } from 'shared-client/types/test';

interface EditStatusLabelProps extends WithTestIdOptional {
	label: string;
	value: any;
}

function EditStatusLabel({ label, value, testId }: EditStatusLabelProps) {
	const emProps = {
		...(testId && { 'data-testid': `status-label-${testId}` }),
	};

	return value ? (
		<>
			<strong>{label + ': '}</strong>
			<em {...emProps}>{value}</em>
			<br />
		</>
	) : null;
}

export default React.memo(EditStatusLabel);
